var map = {
	"./clutch.svg": "7b26",
	"./linkedin.svg": "d25a",
	"./next.svg": "c133",
	"./prev.svg": "5389",
	"./skype.svg": "074c",
	"./telegram.svg": "350a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fed3";